import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { CartService } from './cart.service';

import { CartComponent } from './cart/cart.component';
import { CartListComponent } from './cart/cart-list/cart-list.component';
import { PaymentComponent } from "./cart/payment/payment.component";
import { CartSearchComponent } from './cart/cart-search/cart-search.component';
import { PaymentService } from './services/payment.service';
import { ItemsListComponent } from '../items/items-list/items-list.component';
import { AppModule } from '../app.module';
import { StoreModule } from '@ngrx/store';
import * as fromCart from './state/cart.reducers';
import { EffectsModule } from '@ngrx/effects';
import { CartEffects } from './state/cart.effects';




@NgModule({
  declarations: [
    CartComponent,
    CartListComponent,
    CartSearchComponent,
    PaymentComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    // ItemsListComponent,
    StoreModule.forFeature(fromCart.cartFeatureKey, fromCart.reducer),
    EffectsModule.forFeature([CartEffects])
  ],
  exports: [
    CartComponent,
    // ItemsListComponent
  ],
  providers: [
    CartService,
    PaymentService
  ]
})
export class CartModule { }
